module.exports = __webpack_public_path__ + "img/sglogo_icon.af5e2548.png";